import { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './exclusiveToggleButtonGroup.module.scss';
import { ExclusiveToggleButtonContextProvider } from '../../contexts';

export const ExclusiveToggleButtonGroup = memo(({ onChange, className, value, children }) => {
  const [selectedValue, setSelectedValue] = useState(value);
  const onChangeWrapper = useCallback(
    (next) => {
      if (next === value) return;
      onChange?.(next);
      setSelectedValue(next);
    },
    [onChange, value],
  );
  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  return (
    <ExclusiveToggleButtonContextProvider value={{ selectedValue, setSelectedValue: onChangeWrapper }}>
      <div className={classNames(styles.container, className)} role="radiogroup">
        {children}
      </div>
    </ExclusiveToggleButtonContextProvider>
  );
});

ExclusiveToggleButtonGroup.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

ExclusiveToggleButtonGroup.defaultProps = {
  className: undefined,
  onChange: undefined,
};
